export default "__VITE_ASSET__DgTBcXbA__"